import React from "react";

export const OtherField = ({...props}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 512 512"
			{...props}
		>
			<path
				fill="#0a789b"
				d="M69 392c-33.084 0-60 26.916-60 60s26.916 60 60 60 60-26.916 60-60-26.916-60-60-60zm0 100c-22.056 0-40-17.944-40-40s17.944-40 40-40 40 17.944 40 40-17.944 40-40 40z"
			/>
			<path
				fill="#0a617d"
				d="M472.326 463.375C489.751 460.297 503 445.606 503 427.989 503 408.145 486.195 392 465.54 392h-26.573l-.016.001-.016-.001c-5.522 0-10 4.478-10 10v100c0 5.522 4.478 10 10 10s10-4.478 10-10v-34.931l36.559 41.537a9.976 9.976 0 007.511 3.394 9.962 9.962 0 006.603-2.493c4.146-3.649 4.549-9.968.9-14.113zM465.54 412c9.464 0 17.46 7.322 17.46 15.989s-7.996 15.988-17.46 15.988c-3.779 0-10.652.03-16.445.061-.03-5.692-.08-26.102-.097-32.038z"
			/>
			<path
				fill="#0a789b"
				d="M314.601 392c-5.522 0-10 4.478-10 10v38.285H255.4V402c0-5.522-4.478-10-10-10s-10 4.478-10 10v100c0 5.522 4.478 10 10 10s10-4.478 10-10v-41.715h49.201V502c0 5.522 4.478 10 10 10s10-4.478 10-10V402c0-5.522-4.478-10-10-10z"
			/>
			<path
				fill="#0a617d"
				d="M324.601 502V402c0-5.522-4.478-10-10-10s-10 4.478-10 10v38.285H256v20h48.601V502c0 5.522 4.478 10 10 10s10-4.478 10-10zM399.068 412c5.522 0 10-4.478 10-10s-4.478-10-10-10h-42.137c-5.522 0-10 4.478-10 10v100c0 5.522 4.478 10 10 10h42.137c5.522 0 10-4.478 10-10s-4.478-10-10-10h-32.137v-30h29.029c5.522 0 10-4.478 10-10s-4.478-10-10-10h-29.029v-30z"
			/>
			<path
				fill="#0a789b"
				d="M203.613 392h-55.227c-5.522 0-10 4.478-10 10s4.478 10 10 10h17.502v90c0 5.522 4.478 10 10 10s10-4.478 10-10v-90h17.725c5.522 0 10-4.478 10-10s-4.477-10-10-10z"
			/>
			<g>
				<path
					fill="#0a789b"
					d="M239.543 255.003a9.946 9.946 0 01-4.02-.849c-5.056-2.223-7.353-8.123-5.13-13.179L268.187 155h-39.694c-5.522 0-10-4.478-10-10s4.478-10 10-10h55.014a10 10 0 019.154 14.024l-43.959 100a10.002 10.002 0 01-9.159 5.979z"
				/>
			</g>
			<path
				fill="#0a617d"
				d="M283.507 135H256v20h12.188L256 182.725v49.698l36.661-83.398A10 10 0 00283.507 135z"
			/>
			<g>
				<path
					fill="#ccfc5c"
					d="M216.608 300.641l-36.437-36.446c-5.857-5.858-15.354-5.859-21.213-.002s-5.86 15.354-.003 21.213l10.837 10.84h-35.114c-10.789 0-20.44-5.537-25.881-14.828-5.574-9.519-5.268-21.387.325-30.895l34.806-59.172c4.2-7.141 1.817-16.334-5.324-20.534-7.141-4.2-16.334-1.816-20.534 5.324l-35.108 59.685c-11.05 18.783-11.188 41.292-.367 60.209 10.819 18.918 30.29 30.212 52.083 30.212h35.114l-10.837 10.84c-5.857 5.858-5.856 15.356.003 21.213s15.356 5.856 21.213-.003l36.437-36.445c5.856-5.858 5.856-15.354 0-21.211z"
				/>
			</g>
			<path
				fill="#9cdd05"
				d="M434.668 182.997l-49.678-13.71c-7.984-2.204-16.244 2.481-18.449 10.466l-13.721 49.675c-2.206 7.985 2.48 16.247 10.465 18.452 7.985 2.206 16.246-2.479 18.452-10.465l4.292-15.536 17.151 29.157c5.576 9.479 5.594 20.855.031 30.367-5.459 9.336-15.691 14.843-26.507 14.843H306c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15h71.321c21.793 0 41.264-11.294 52.083-30.212 10.82-18.917 10.683-41.426-.367-60.209l-16.334-27.769 13.985 3.859c7.986 2.204 16.246-2.483 18.45-10.469 2.203-7.985-2.484-16.245-10.47-18.449z"
			/>
			<path
				fill="#ccfc5c"
				d="M343.929 91.141l-36.213-61.562C296.821 11.058 277.488 0 256 0s-40.821 11.058-51.716 29.579L185.6 61.341l-4.801-16.268c-2.345-7.946-10.687-12.486-18.633-10.141-7.945 2.345-12.485 10.686-10.14 18.631l14.587 49.428c2.344 7.944 10.684 12.484 18.629 10.142l49.431-14.574c7.946-2.343 12.489-10.684 10.146-18.63s-10.684-12.488-18.63-10.146l-13.006 3.835 16.958-28.829C235.59 35.529 245.256 30 256 30s20.41 5.529 25.858 14.79l36.213 61.561c4.2 7.14 13.394 9.524 20.534 5.323 7.141-4.2 9.524-13.393 5.324-20.533z"
			/>
			<path
				fill="#9cdd05"
				d="M281.858 44.79l36.213 61.561c4.2 7.14 13.394 9.524 20.534 5.323 7.14-4.2 9.524-13.394 5.323-20.534l-36.213-61.562C296.821 11.058 277.488 0 256 0v30c10.744 0 20.41 5.529 25.858 14.79z"
			/>
		</svg>
	);
}

export default OtherField;
